import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, unref as _unref, withModifiers as _withModifiers, normalizeClass as _normalizeClass, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "tw-flex tw-cursor-default tw-flex-col tw-gap-2 tw-rounded-full tw-bg-orange-50 tw-p-2" }
const _hoisted_2 = { class: "tw-flex tw-gap-1 tw-text-2xs tw-text-deep-orange-600" }
const _hoisted_3 = {
  key: 0,
  class: "tw-flex tw-flex-col tw-gap-2"
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", { class: "tw-text-xs tw-text-red-500" }, "Error fetching usage data", -1)
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = {
  key: 1,
  class: "tw-flex tw-flex-col tw-gap-2"
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "tw-px-4 tw-text-sm tw-font-medium" }, "Used In", -1)
const _hoisted_8 = { class: "tw-space-y-2 tw-text-xs" }
const _hoisted_9 = ["disabled", "onClick"]
const _hoisted_10 = ["title"]
const _hoisted_11 = { class: "tw-block tw-w-full tw-truncate tw-text-left" }
const _hoisted_12 = {
  key: 0,
  class: "tw-block tw-w-full tw-truncate tw-text-left tw-text-2xs tw-text-slate-500"
}
const _hoisted_13 = {
  key: 1,
  class: "tw-flex tw-w-full tw-flex-col tw-items-start"
}
const _hoisted_14 = /*#__PURE__*/_createElementVNode("span", { class: "tw-block tw-w-full tw-truncate tw-text-left tw-text-2xs tw-text-slate-500" }, "DELETED", -1)
const _hoisted_15 = [
  _hoisted_14
]

import { listVideoAssetUsage, VideoAssetUsage } from '@goldcast/api/backend';
import { ref } from 'vue';

import { redirectToUsage, transformVideoAssetUsageEntityType } from '../utils';
import { VideoAsset } from '../videoLibraryService';

import TablerBroadcast from '@/studioComponents/Icons/tabler/TablerBroadcast.vue';
import TablerLoader2 from '@/studioComponents/Icons/tabler/TablerLoader2.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'VideoLibraryTableItemUsageHover',
  props: {
    videoAsset: {},
    tooltipDirection: {}
  },
  setup(__props: any) {

const props = __props;



const usageData = ref<VideoAssetUsage[] | null>(null);
const usageLoading = ref(false);
const usageFetchError = ref<Error | null>(null);

const showUsagePopover = ref(false);
const isHovered = ref(false);

const onMouseEnter = () => {
  isHovered.value = true;
  if (usageData.value) {
    showUsagePopover.value = true;
    return;
  }

  usageLoading.value = true;
  listVideoAssetUsage({
    id: props.videoAsset.id
  })
    .then(response => {
      usageData.value = response;
      if (usageData.value && usageData.value.length > 0 && isHovered.value) {
        showUsagePopover.value = true;
      }
    })
    .catch(error => {
      usageFetchError.value = error;
    })
    .finally(() => {
      usageLoading.value = false;
    });
};

const onMouseLeave = () => {
  isHovered.value = false;
  showUsagePopover.value = false;
};

const onUsageClick = (usage: VideoAssetUsage): void => {
  redirectToUsage(usage);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "tw-relative",
    onMouseenter: onMouseEnter,
    onMouseleave: onMouseLeave,
    onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"]))
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        (usageLoading.value)
          ? (_openBlock(), _createBlock(TablerLoader2, {
              key: 0,
              class: "tw-h-4 tw-w-4 tw-animate-spin"
            }))
          : (_openBlock(), _createBlock(TablerBroadcast, {
              key: 1,
              class: "tw-h-4 tw-w-4"
            })),
        _createElementVNode("span", null, _toDisplayString(_ctx.videoAsset.usageCount), 1)
      ])
    ]),
    _createVNode(_Transition, {
      enterActiveClass: "tw-transition tw-duration-200 tw-ease-out",
      enterFromClass: "tw-transform tw-scale-95 tw-opacity-0",
      enterToClass: "tw-transform tw-scale-100 tw-opacity-100",
      leaveActiveClass: "tw-transition tw-duration-150 tw-ease-in",
      leaveFromClass: "tw-transform tw-scale-100 tw-opacity-100",
      leaveToClass: "tw-transform tw-scale-95 tw-opacity-0"
    }, {
      default: _withCtx(() => [
        (showUsagePopover.value && usageData.value && usageData.value.length > 0)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: _normalizeClass(["tw-absolute tw-z-50 tw-flex tw-max-h-[200px] tw-w-64 tw-cursor-default tw-flex-col tw-gap-2 tw-overflow-y-auto tw-rounded-md tw-border tw-bg-white tw-py-4 tw-shadow-md", { 'tw-bottom-8 tw-mt-1': _ctx.tooltipDirection === 'up', 'tw-top-8 tw-mb-1': _ctx.tooltipDirection === 'down' }])
            }, [
              (usageFetchError.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_3, _hoisted_5))
                : (usageData.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                      _hoisted_7,
                      _createElementVNode("ul", _hoisted_8, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(usageData.value, (usage) => {
                          return (_openBlock(), _createElementBlock("li", {
                            key: usage.entity_id
                          }, [
                            _createElementVNode("button", {
                              disabled: !usage.entity_id,
                              class: "tw-flex tw-w-full tw-cursor-pointer tw-px-4 tw-py-2 hover:tw-bg-slate-50",
                              onClick: _withModifiers(($event: any) => (onUsageClick(usage)), ["stop"])
                            }, [
                              (usage.entity_id)
                                ? (_openBlock(), _createElementBlock("div", {
                                    key: 0,
                                    title: usage.entity_title,
                                    class: "tw-flex tw-w-full tw-flex-col tw-items-start"
                                  }, [
                                    _createElementVNode("span", _hoisted_11, _toDisplayString(usage.entity_title), 1),
                                    (usage.entity_title)
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_12, _toDisplayString(usage.entity_subtype || _unref(transformVideoAssetUsageEntityType)(usage)), 1))
                                      : _createCommentVNode("", true)
                                  ], 8, _hoisted_10))
                                : (_openBlock(), _createElementBlock("div", _hoisted_13, _hoisted_15))
                            ], 8, _hoisted_9)
                          ]))
                        }), 128))
                      ])
                    ]))
                  : _createCommentVNode("", true)
            ], 2))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ], 32))
}
}

})